/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const kollektivet: CommunityData = {
  code: "kollektivet",
  name: "Kollektivet Livet",
  thumbnail: "/assets/customizations/kollektivet/kollektivet-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kol-405`,
  socials: {
    instagramLink: "https://www.instagram.com/kollektivetlivet_bar/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#000000",
      alternativeLogo: {
        src: "/assets/customizations/kollektivet/logo-white.svg",
        styles: "w-[148px]",
      },
      logo: {
        src: "/assets/customizations/kollektivet/logo.svg",
        styles: "w-[212px] h-[85px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#343333",
      asideStyles: "",
      asideBg: "#000000",
      contentBg: "#ffffff",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/kollektivet/kollektivet-bg.png",
      bgMobile: "/assets/customizations/kollektivet/kollektivet-bg.png",
      nonMemberBg: "/assets/customizations/kollektivet/kollektivet-bg.png",
      mainFont: "font-['Barlow']",
      primaryButton:
        "w-full sm:w-fit !h-[44px] bg-black !px-8 !text-base !leading-[1] font-['Barlow'] !text-white whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-[#FFFFFF] border-t",
      item: "font-['Kollektivet'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center uppercase text-[#FFFFFF] !pt-2",
      itemSelected: "bg-[#424549] text-[#FFFFFF]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[35px] pb-2",
      announcements: {
        customBg: "bg-[#000000]",
        lg: {
          title: "text-base sm:text-[32px] leading-[1] font-['Kollektivet'] mb-1",
          subtitle: "text-[12px] leading-[1] font-semibold !text-white",
        },
        sm: {
          title: "text-base sm:text-[18px] leading-[1] font-['Kollektivet'] mb-2",
          subtitle: "text-[12px] leading-[1] font-semibold !text-white",
        },
      },
      event: {
        title: "text-base font-semibold leading-[16px] text-black",
        subtitle: "text-base leading-5 text-black",
      },
      shop: {
        title: "font-['Kollektivet'] uppercase text-black text-[28px] leading-[31px]",
        text: "text-[16px] leading-[20px] text-black",
        customShopImage: "/assets/customizations/kollektivet/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[32px]",
      title: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[35px] pb-2",
      description: "text-[12px] leading-[1] font-semibold !text-white",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[35px] pb-2",
      description: "text-[12px] leading-[1] font-semibold !text-white",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[35px]",
      sectionSubtitle: "text-[16px] leading-5 text-black",
      text: "text-[16px] leading-5 text-black",
      separator: "border-b border-black",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#000000",
        strokeColor: "border-[#000000]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "font-['Kollektivet'] uppercase text-black text-[32px] leading-[35px]",
        subtitle: "text-[16px] leading-5 text-black",
      },
      ticket: {
        counterContainer: "",
        title: "text-[28px] leading-[31px] font-['Kollektivet'] text-black uppercase",
        description: "font-['Kollektivet'] text-[20px] leading-5",
        text: "text-[16px] leading-[20px] text-black",
        price: "text-[28px] leading-[31px] font-['Kollektivet'] text-black",
        quantity: "text-[20px] leading-6 text-black",
      },
    },
  },
}

export default kollektivet
